export const avatarStyle = ({ colr, theme }) => ({
    color: colr,
    backgroundColor: theme.palette[colr]?.main,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '16px'
});